import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../LanguageContext';
import type { Bi } from '../../data/sectors';
import { sectorsCta as c } from '../../data/sectorsPage';
const EASE = [0.23, 1, 0.32, 1] as const;
export function SectorsCTA() {
  const {
    lang
  } = useLanguage();
  const pick = (b: Bi) => lang === 'FR' ? b.fr : b.en;
  return <section className="relative overflow-hidden bg-white border-t border-[#EEF0F4] px-6 py-24 lg:py-28" aria-labelledby="sectors-cta-title" data-id="element-6585" data-mp="mjcvq8sa4vw5">
      <div className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[760px] h-[360px] rounded-full bg-[#F1F0FD] opacity-70 blur-[140px]" aria-hidden="true" data-id="element-6586" data-mp="cnrpfyg6h9gl" />
      <motion.div initial={{
      opacity: 0,
      y: 12
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 0.3,
      ease: EASE
    }} className="relative max-w-[820px] mx-auto text-center" data-id="element-6587" data-mp="2xcz8ffy4sj1w">
        <h2 id="sectors-cta-title" className="font-serif text-[2.1rem] sm:text-[2.6rem] lg:text-[3.1rem] leading-[1.06] tracking-tight" data-id="element-6588" data-mp="kza6s1ce7eaw">
          {c.headline.map(l => <span key={l.text.fr} className={`block ${l.accent ? 'text-[#4F46E5]' : 'text-[#121A3A]'}`} data-id="element-6589" data-mp="tzf41invgwbc">{pick(l.text)}</span>)}
        </h2>
        <p className="mt-8 max-w-[620px] mx-auto font-sans text-[15.5px] md:text-[17px] text-[#4A5268] leading-relaxed" data-id="element-6590" data-mp="13vrw6c3rr23z">{pick(c.body)}</p>
        <Link to="/request-demo" className="mt-9 inline-flex w-full sm:w-auto items-center justify-center gap-3 rounded-xl bg-[#4F46E5] px-10 py-3.5 font-sans text-[16px] font-medium text-white shadow-[0_14px_30px_-14px_rgba(79,70,229,0.7)] hover:bg-[#4338CA] transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#4F46E5] focus-visible:ring-offset-2" data-id="element-6591" data-mp="ywp37q12cmcd">
          {pick(c.cta)}
          <ArrowRightIcon className="w-4 h-4" aria-hidden="true" data-id="element-6592" data-mp="faab9rtkr3ne" />
        </Link>
      </motion.div>
    </section>;
}